module.exports = __webpack_public_path__ + "static/media/IPR.afcd2d87.svg";